/* ********************* request 全局配置文档 ************************/
import Vue from 'vue'
import axios from 'axios'

let lastTimmer = 0
const errorFn = err => {
    if (err.toString().indexOf('timeout') !== -1) {
        console.error('请求超时，请稍后再试')
    }
    if (err && err.response) {
        switch (err.response.status) {
        case 400:
            err.message = err.response.data.message || '请求错误'
            break

        case 401:
            err.message = err.response.data.msg || '未授权，请登录'
            window.location.href = err.response.data.loginUrl // sso登录页
            break

        case 403:
            err.message = '暂无权限'
            break

        case 404:
            err.message = `请求地址出错: ${err.response.config.url}`
            break

        case 408:
            err.message = '请求超时'
            break

        case 500:
            err.message = '服务正忙，请您稍后再试'
            break

        case 501:
            err.message = '服务正忙，请您稍后再试'
            break

        case 502:
            err.message = '服务正忙，请您稍后再试'
            break

        case 503:
            err.message = '服务正忙，请您稍后再试'
            break

        case 504:
            err.message = '服务正忙，请您稍后再试'
            break

        case 505:
            err.message = '服务正忙，请您稍后再试'
            break

        default:
            err.message = '请求失败，请稍后再试'
        }
        const thisTimer = new Date().getTime()
        if (thisTimer - lastTimmer > 5000 && err.response.status !== 401) {
            console.error(err.message)
            lastTimmer = thisTimer
        }
    }
    return Promise.reject(err)
}
/**
 * func: 自定义Axios
 */
const service = axios.create({
    baseURL: '',
    timeout: 8000,
    withCredentials: true
})
service.interceptors.request.use(
    config => {
        if (config.method === 'get') {
            if (config.url.indexOf('?') < 0) {
                config.url += '?r=' + new Date().getTime()
            } else {
                config.url += '&r=' + new Date().getTime()
            }
        }
        if (window.contactsToken) {
            config.headers.token = window.contactsToken
        }
        return config
    },
    error => {
        return Promise.reject(error)
    }
)
service.interceptors.response.use(
    response => {
        // 处理返回体
        const result = response.data
        const code = Number(result.code)
        /**
         * Desc: 接口请求业务异常统一处理
         * Desc: 如：50008: 非法Token; 50012: 第三端登录; 50014: Token已过期;
         */
        if (
            code === 3002 ||
            code === 50008 ||
            code === 50012 ||
            code === 50014 ||
            code === 302
        ) {
            alert('您已退出登录')
        } else {
            if (result.code && result.code !== '200') {
                console.log(result.message)
            }
            // 通讯录接口返回code为401时，做登出拦截 -> token失效
            if (code === 401) {
                const responseUrl = response.config.url
                const isContacts = responseUrl.indexOf('/contacts/open/')
                if (isContacts !== -1) {
                    Vue.prototype.$message({
                        message: '服务异常，请联系IT报事',
                        type: 'error',
                        duration: 3000
                    })
                    // window.location.href = result.loginUrl // sso登录页
                }
            }
            return result
        }
    },
    errorFn // HTTP Code异常统一处理
)
export default service
